export enum TYPES {
  TOGGLE_SIDEBAR = '@@sidebar/TOGGLE_SIDEBAR'
}

export interface SIDEBAR {
  isOpen: boolean
}
